import axiosClient from "../../../utils/axios";
import { ApiResponse } from "../../../types/api.types";
import { ApiOptionList } from "../../../components/common/DeptTeamSelector/api/organization.api";
import type { TeamSurveyData } from "../types/teamSurvey.types";


export const updateTeamMembers = async (payload: {
  team_id: number;
  name: string;
  lead_id: number;
  department_id: number;
  user_ids: number[];
}) => {
  try {
    const response = await axiosClient.put<ApiResponse<any>>(
      "/teams",
      payload
    );

    return response.data;

  } catch (err) {
    console.warn("Error updating team members :", err);
    throw err;
  }
};


export const getUserOptions = async ({
  query,
  limit,
  page,
  organizationId,
}: {
  query?: string;
  limit?: number;
  page?: number;
  organizationId?: number;
}) => {
  try {

    const response = await axiosClient.post<
      ApiResponse<ApiOptionList>
    >("/user/dropdown", {
      query: query ?? null,
      limit: limit ?? null,
      page: page ?? null,
      organization_id: organizationId ?? null,
    });

    return response.data;

  } catch (err) {
    console.warn("Error fetching User Dropdown :", err);
    throw err;
  }
};
export const getTeamSurvey = async ({
  team_id,
  questionnaire_id,
}: {
  team_id: number;
  questionnaire_id: number;
}) => {
  try {
    const response = await axiosClient.post<
      ApiResponse<TeamSurveyData>
    >("/teams/survey", {
      team_id,
      questionnaire_id,
    });

    return response.data;
  } catch (err) {
    console.warn("Error fetching team survey :", err);
    throw err;
  }
};
export const getUserSurveyScores = async ({
  questionnaire_id,
  user_id,
}: {
  questionnaire_id: number;
  user_id: number;
}) => {
  try {
    const response = await axiosClient.post("/survey/user-scores", {
      questionnaire_id,
      user_id,
    });

    return response.data;
  } catch (err) {
    console.error("Error fetching user survey scores:", err);
    throw err;
  }
};

export const getTeamCompositeScores = async ({
  questionnaire_id,
  team_id,
}: {
  questionnaire_id: number;
  team_id: number;
}) => {
  try {
    const response = await axiosClient.post(
      "/survey/team-composite-scores",
      {
        questionnaire_id,
        team_id,
      }
    );

    return response.data;
  } catch (err) {
    console.error("Error fetching team scores:", err);
    throw err;
  }
};

export type TeamMemberScore = {
  user_id: number;
  first_name: string;
  last_name: string;
  nick_name: string | null;
  email: string;
  image?: string;
  scores: Record<string, number>;
};

export type TeamMemberScoresResponse = {
  success: boolean;
  message: string;
  data: {
    questionnaire_id: number;
    team_id: number;
    total_completed: number;
    members: TeamMemberScore[];
  };
};

export const getTeamMemberScores = async ({
  questionnaire_id,
  team_id,
  limit = 5,
}: {
  questionnaire_id: number;
  team_id: number;
  limit?: number;
}): Promise<TeamMemberScoresResponse> => {
  try {
    const response = await axiosClient.post<TeamMemberScoresResponse>(
      "/survey/team-member-scores",
      { questionnaire_id, team_id, limit }
    );
    return response.data;
  } catch (err) {
    console.error("Error fetching team member scores:", err);
    throw err;
  }
};